import { Link } from 'react-router-dom';
import { ROUTE_PATH } from '../../constants';
import * as React from 'react';

type ShareLinkProps = {
  link?: string;
  subject: string;
};

export const ShareLink: React.FunctionComponent<ShareLinkProps> = (props) => (
  <Link
    to={{
      pathname: ROUTE_PATH.SHARE,
      state: { link: props.link, subject: props.subject },
    }}
  >
    {props.children}
  </Link>
);
